// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 767.98px) {\n.h-switcher[data-v-0c34e7a4] .c-switcher-group {\n    width: 100%;\n}\n.h-switcher[data-v-0c34e7a4] .c-switcher-group-item {\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n}\n}\n.c-input-label[data-v-0c34e7a4] {\n  padding-top: 6px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n", ""]);
// Exports
module.exports = exports;
